// extracted by mini-css-extract-plugin
export var activeDot = "_3f-c";
export var buttonContainer = "_3f-9";
export var channelButton = "_3f-a";
export var clickable = "_3f-d";
export var content = "_3f-0";
export var contentFull = "_3f-2";
export var contentThird = "_3f-1";
export var contentWrapper = "_3f-7";
export var description = "_3f-5";
export var heightShort = "_3f-f";
export var image = "_3f-3";
export var imageContainer = "_3f-4";
export var selectButton = "_3f-e";
export var spinnerContainer = "_3f-b";
export var titleContent = "_3f-8";
export var titleWrapper = "_3f-6";